export default __webpack_public_path__ + "static/media/la.9f10257a.svg";